/**
 * Alertas antecipados de rotinas LST (Push / Andon visual).
 */

import type { LstRotinaDoDia, LstTemplate } from '../types';

export interface LstUpcomingAlert {
  templateId: string;
  title: string;
  scheduledTime: string;
  minutesUntil: number;
  alertLeadMinutes: number;
  channel: 'push' | 'andon' | 'both';
  isCritical: boolean;
}

function nowMinutes(): number {
  const n = new Date();
  return n.getHours() * 60 + n.getMinutes();
}

function timeToTodayMinutes(time: string): number | null {
  if (!/^\d{1,2}:\d{2}$/.test(time)) return null;
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

/** Rotinas que entram na janela de alerta antecipado agora. */
export function scanUpcomingAlerts(rotinas: LstRotinaDoDia[]): LstUpcomingAlert[] {
  const now = nowMinutes();
  const alerts: LstUpcomingAlert[] = [];

  for (const r of rotinas) {
    if (r.status === 'realizado') continue;
    const t = r.template;
    if (!t.scheduled_time) continue;
    const target = timeToTodayMinutes(t.scheduled_time);
    if (target == null) continue;
    const lead = t.alert_lead_minutes ?? 10;
    const diff = target - now;
    if (diff > 0 && diff <= lead) {
      alerts.push({
        templateId: t.id,
        title: t.title,
        scheduledTime: t.scheduled_time,
        minutesUntil: diff,
        alertLeadMinutes: lead,
        channel: t.alert_channel ?? 'andon',
        isCritical: t.is_critical,
      });
    }
  }
  return alerts.sort((a, b) => a.minutesUntil - b.minutesUntil);
}
